import { action as apiAction } from 'api/Api'
import {
  add as addChecklistItem
} from '../redux/checklistItems'
import {
  addItem as addItemToChecklist
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  checklistId: number
  name: string
}

export default (payload: Payload) => async dispatch => {
  const { cardId, checklistId, name } = payload

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, [
    addChecklistItem({
      cardId,
      checklistItem: {
        id: tempId,
        name,
        isBusy: true
      }
    }),
    addItemToChecklist({
      elementId: checklistId,
      itemId: tempId,
      index: undefined
    })
  ])

  try {
    await apiAction('AddChecklistItem', {
      checklistId,
      rtName: name
    })
  } finally {
    optimisticAction.revert()
  }
}
